export const hasPerm = (user, perm) => {
  const p = user?.effective_permissions || [];
  return p.includes("*") || p.includes(perm);
};

// Standard platform features: enabled by default for every tenant unless the tenant
// explicitly has the flag set to false (reserved for future plan-level restriction).
const DEFAULT_ON_MODULES = new Set(["service_profitability"]);

export const moduleOn = (user, flag) => {
  const ff = user?.tenant?.feature_flags || {};
  if (DEFAULT_ON_MODULES.has(flag)) return ff[flag] !== false;
  return !!ff[flag];
};
